export const PROFILES = Object.freeze({
    FORECAST_MANAGER: "FORECAST_MANAGER",
    ZONE_READER: "ZONE_READER",
    ZONE_FORECASTER: "ZONE_FORECASTER",
    ZONES_SUPERVISOR: "ZONES_SUPERVISOR",
    COORDINATOR: "COORDINATOR"
});



// WEBPACK FOOTER //
// ./src/plugins/constant.js